import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import './styles.less';

const EnrollmentCheckList = () => {
  const items = [
    'Ser mayor de 18 años y persona natural.',
    'Tus datos personales.',
    'Cédula de Identidad en formato digital por ambos lados.',
    'Cuenta Corriente bancaria asociada a tu RUT.',
  ];

  return (
    <div className="enrollment-check-list">
      <p>
        <b>Recuerda tener a mano</b>
      </p>
      <ol className="enrollment-check-list__ol">
        {items.map((item, index) => {
          const key = `item_${index}`;

          return (
            <li key={key}>
              <p>
                <CheckOutlined className="enrollment-check-list__check" />{' '}
                <span className="enrollment-check-list__item__text">{item}</span>
              </p>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default EnrollmentCheckList;
